import { LowerCasePipe, NgClass } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';

import { Fai, FaimUnlimited, Plan, ProductFactory, QuoteModel } from '@bytel/bytel-sales';

import { REINSURANCE_CHOICES, REINSURANCE_TYPES } from '@base/common/constants/index';

import { MainCartService } from '@services/main-cart.service';

import { BasicObject } from '../../interfaces/checkout.interface';
import { ConfigurationService } from '../../services/configuration.service';
import { translations } from '../../translation.constants';

@Component({
    selector: 'checkout-reinsurance',
    templateUrl: './reinsurance.component.html',
    styleUrl: 'reinsurance.component.scss',
    standalone: true,
    imports: [NgClass, LowerCasePipe],
})
export class ReinsuranceComponent implements OnInit {
    public choicesByType: BasicObject = {
        [REINSURANCE_TYPES.DEFAULT]: [
            REINSURANCE_CHOICES.FREE_SHIPPING,
            REINSURANCE_CHOICES.PROMOTIONS,
            REINSURANCE_CHOICES.SECURE_PAYMENT,
            REINSURANCE_CHOICES.CUSTOMER_SERVICE,
        ],
        [REINSURANCE_TYPES.FAI]: [
            REINSURANCE_CHOICES.TERMINATION_FEES,
            REINSURANCE_CHOICES.NO_COMMITMENT,
            REINSURANCE_CHOICES.SECURE_PAYMENT,
            REINSURANCE_CHOICES.PROMOTIONS,
            REINSURANCE_CHOICES.FREE_SHIPPING,
        ],
        [REINSURANCE_TYPES.MOBILE]: [
            REINSURANCE_CHOICES.NETWORK_4G,
            REINSURANCE_CHOICES.FREE_SHIPPING,
            REINSURANCE_CHOICES.CHECKED_REVIEW,
            REINSURANCE_CHOICES.PROMOTIONS,
        ],
    };
    public configuration: BasicObject = {
        [REINSURANCE_CHOICES.FREE_SHIPPING]: {
            icon: 'tri-courier',
        },
        [REINSURANCE_CHOICES.PROMOTIONS]: {
            icon: 'tri-euros',
        },
        [REINSURANCE_CHOICES.SECURE_PAYMENT]: {
            icon: 'tri-credit-card-lock',
        },
        [REINSURANCE_CHOICES.CUSTOMER_SERVICE]: {
            icon: 'tri-user-headset',
        },
        [REINSURANCE_CHOICES.TERMINATION_FEES]: {
            icon: 'tri-promo-label-50',
            isHidden: false,
        },
        [REINSURANCE_CHOICES.NO_COMMITMENT]: {
            icon: 'tri-v-sign',
            isHidden: true,
        },
        [REINSURANCE_CHOICES.NETWORK_4G]: {
            icon: 'tri-5g-4g-plus',
        },
        [REINSURANCE_CHOICES.CHECKED_REVIEW]: {
            icon: 'tri-smile',
        },
    };
    public type: string = REINSURANCE_TYPES.DEFAULT;
    public translations: BasicObject = translations.reinsurance;
    protected configService: ConfigurationService = inject(ConfigurationService);
    constructor(protected cartService: MainCartService) {}

    ngOnInit(): void {
        const quote: QuoteModel = this.cartService.getQuote();
        const plan: Plan = quote.getPrincipalProduct<Plan>('Plan');
        const odrConfig = this.configService.getData().global.reinsurance?.noOdr;
        if (plan && (ProductFactory.Is(plan, Fai) || ProductFactory.Is(plan, FaimUnlimited))) {
            this.type = REINSURANCE_TYPES.FAI;
            const shouldShowNoCommitment =
                odrConfig?.commercialSeries?.includes(plan.data.commercial_series) ||
                odrConfig?.rangesNg?.includes(plan.data.range_ng);

            if (shouldShowNoCommitment) {
                this.configuration[REINSURANCE_CHOICES.NO_COMMITMENT].isHidden = false;
                this.configuration[REINSURANCE_CHOICES.TERMINATION_FEES].isHidden = true;
            }
        } else if (plan) {
            this.type = REINSURANCE_TYPES.MOBILE;
        }
    }
}
